import * as cap from './capture';
import * as pack from './pack';
import * as sell from './sell';
import * as set from './settings';

/** Route name → view function. Each returns the HTML for <main>. */
export const Views: Record<string, (...args: string[]) => string> = {
  setup: cap.setup, capture: cap.capture, review: cap.review, decide: cap.decide, inventory: cap.inventory, inventoryList: cap.inventoryList, item: cap.item,
  scenarios: pack.scenarios, customs: pack.customs, boxes: pack.boxes, box: pack.box, labels: pack.labels, shipments: pack.shipments, shipment: pack.shipment, unpack: pack.unpack,
  sale: sell.sale, sales: sell.sales, pos: sell.pos, antiques: sell.antiques, donations: sell.donations, insurance: sell.insurance, closeout: sell.closeout,
  settings: set.settings, signin: set.signin, claim: set.claim, dev: set.dev, notFound: set.notFound,
};
export { boxLabelData } from './pack';
